import {
    mapState
} from 'vuex'
import AppData from '../../api/AppData'
// import { TimelineLite } from 'gsap'
import { gsap } from 'gsap'


export default {
    name: 'app-loading',

    mounted() {
        const { animContent,animVisual} = this.$refs
        // const timeline = new TimelineLite() 

        gsap.from(animVisual, {
            opacity: .5, 
            rotation: 0, 
            x: -250, 
            duration: 1.8,
            ease: "power4.out"
        });

        if(this.$mq === 'lg') {
            gsap.from(animContent, {
                opacity: .5,
                rotation: 0,
                x: 250, 
                duration: 1.8,
                ease: "power4.out"
            });
        } else {
            gsap.from(animContent, {
                opacity: .5,
                rotation: 0,
                y: 250, 
                duration: 1.8,
                ease: "power4.out"
            });
        }
    },

    created() {
        for (const vid of AppData.markers) {
            this.$store.dispatch({
                type: 'downloadVideo',
                videoUrl: vid.slug + '.mp4'
            })
        }
    },

    computed: {
        ...mapState(['progress'])
    }
}
